module.exports = __webpack_public_path__ + "img/banner3.e37438eb.png";